export var province = [
   
]


export var cities = {
    id: 1,
    name: "delhi",
}


// WEBPACK FOOTER //
// ./src/config/india.js